"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skeletonAnimation = exports.getLoadingAnimationForEmptyImage = void 0;
var _mui = require("@ori-ui/mui");
const skeletonAnimation = exports.skeletonAnimation = (0, _mui.keyframes)`
    to {
        background-position: 200%;
    }
`;
const getLoadingAnimationForEmptyImage = theme => ({
  '&:empty': {
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationName: skeletonAnimation,
    animationTimingFunction: 'linear',
    aspectRatio: '1 / 1',
    backgroundColor: theme.palette.grey[100],
    backgroundImage: `linear-gradient(
      90deg,
      ${theme.palette.grey[100]} 0,
      ${theme.palette.grey[200]} 20%,
      ${theme.palette.grey[100]} 40%
    )`,
    backgroundPosition: 0,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '50% 100%'
  }
});
exports.getLoadingAnimationForEmptyImage = getLoadingAnimationForEmptyImage;
